import { reportRoutes } from '@routes'

type ReportsList = {
  category: string
  reports: { title: string; path: string }[]
}[]

/**
 * Groups the report routes by category, dropping the reports reserved for an
 * Enterprise client the current org is not.
 *
 * Called on render rather than at module import: the org is only known once the
 * session has loaded, which happens after these modules evaluate.
 */
export function getReportsList(isKia: boolean): ReportsList {
  let reportMap = {}
  for (const route of reportRoutes) {
    if (route.enterpriseOnly === 'kia' && !isKia) {
      continue
    }

    if (!reportMap[route.category]) {
      reportMap[route.category] = {
        category: route.category,
        reports: [],
      }
    }
    reportMap[route.category].reports.push(route)
  }

  const reportList: ReportsList = Object.keys(reportMap).map(key => reportMap[key])
  return reportList
}
